export default __webpack_public_path__ + "static/quote-video-2-1f3105469e3c1c763abc1fe61dbd6f21.mp4";